<mat-toolbar class="header">
    <div class = "left">    
        <div class = "cloud-container">
            <a  class="maxis-icon-container" 
            [routerLink]='"/home"' >
                <mat-icon [svgIcon]="'cloud-serve-logo'" class="cloud-serve-logo" alt = "Cloud Serve Logo">
                </mat-icon>
            </a>
        </div>
        <button mat-button
            class = "nav-link"
            [routerLink]='"/home"'>
                Home
        </button>

        <a class = "resources-list">
            <button 
                mat-button 
                [matMenuTriggerFor]="cloudServeResources"
                #resourceMenu="matMenuTrigger"
                [ngClass]="{'resource-menu-open': resourceMenu.menuOpen}"
                class = "nav-link"
                [matTooltip]="'CloudServe Resources'"
                matTooltipClass="tooltip">
                        Resources
                        <img class="dropdown-arrow" src="../../assets/icons/dropdown-arrow-black.svg"/>
            </button>

            <mat-menu #cloudServeResources="matMenu" class = "resource-menu resources-list-menu" >
                <div class = "resources-list">
                    <a  class="resource-menu-item" mat-menu-item
                        href = "https://colibri.opi.gm.com/documents/azure-cloud/workload-architecture/standard-architectures#what-are-tads"
                        target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/timer.svg" alt="timer" class="resource-icon"/>
                            <span>TADS</span>
                            
                    </a>

                    <a class="resource-menu-item" mat-menu-item 
                        href= 'https://generalmotors.sharepoint.com/sites/gmhybridcloud/SitePages/Public-Cloud-Overview.aspx'
                        target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/sharepoint.svg" alt="sharepoint icon" class="resource-icon"/>
                            <span>Multicloud Sharepoint</span>
                    </a>

                    <a  class="resource-menu-item" mat-menu-item
                        href = 'https://azure.microsoft.com/en-ca/pricing/calculator/'
                        target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/dollar-sign.svg" alt="dollar sign" class="resource-icon"/>
                            <span>Azure Pricing</span>
                    </a>

                    <a  class="resource-menu-item" mat-menu-item
                        href="https://colibri.opi.gm.com/documents/azure-cloud/introduction"
                        target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/bird.svg" alt="colibri bird icon" class="resource-icon"/>
                            <span>Documentation</span>
                    </a>

                    <a  class="resource-menu-item" mat-menu-item
                        [href]=yammerUrl
                        target="_blank" rel="noopener noreferrer">
                            <img src="../../../assets/images/viva-engage.svg" alt="yammer icon" class="resource-icon"/>
                            <span>Viva Engage</span>
                    </a>
                </div>
            </mat-menu>
        </a>
    </div>
    
    
    <div class = "right">
        <div class = "user-profile-container">
            <mat-icon
                *ngIf="!user?.photoUrl"
                class="user-photo user-photo-not-found"
                matTooltipClass="tooltip"
                [matTooltip]="user?.name"
                svgIcon="user">
            </mat-icon>
            <img
                *ngIf="user?.photoUrl"
                class="user-photo"
                [src]="user?.photoUrl"
                matTooltipClass="tooltip"
                [matTooltip]="user?.name"
            />
            <a>
                {{user?.email}}
            </a>
        </div>

        <a class = "help"><button 
            mat-icon-button
            [matTooltip]="'Help'"
            matTooltipClass="tooltip"
            (click)="openHelpDialog()">
                <mat-icon [svgIcon]="'help-circle'"></mat-icon>
        </button></a>

        <a class = "product-suite">
            <button 
                mat-icon-button 
                [matMenuTriggerFor]="suite"
                #prodMenu="matMenuTrigger"
                [ngClass]="{'product-suite-open': prodMenu.menuOpen}"
                class = "suite-button"
                [matTooltip]="'Maxis Product Suite'"
                matTooltipClass="tooltip">
                    <mat-icon [svgIcon]="'product-suite-icon'"></mat-icon>
            </button>

            <mat-menu #suite="matMenu" class = "resource-menu product-suite-menu" >
                <div>
                    <a  class="resource-menu-item" mat-menu-item [href]=consumerUrl
                        target="_blank" rel="noopener noreferrer">
                            <span>Consumers</span>    
                    </a>

                    <a  class="resource-menu-item" mat-menu-item [href]=thirdPartyUrl 
                        target="_blank" rel="noopener noreferrer">
                            <span>3rd Parties</span>
                    </a>

                    <a  class="resource-menu-item" mat-menu-item [href]=chartsUrl
                        target="_blank" rel="noopener noreferrer">
                            <span>Maxis Charts</span>
                    </a>
                    
                </div>
            </mat-menu>
        </a>
    </div>

    <!-- <button (click)="testTokenExpiration()">
        Test Token Expiration
      </button> -->

</mat-toolbar>